import dayjs from "dayjs"

import { maxDelay } from "./maxDelay"

type ClearTimeoutCallback = () => void

/*
 * schedule a timeout for a specific time. this function handles scheduling
 * execution for times that are longer than the maximum delay supported by the
 * setTimeout function
 *
 * returns a value for canceling the execution of the timeout
 */
export function setTimeoutForTime(
  dateTimeString: string,
  callback: () => void,
): ClearTimeoutCallback {
  const timeUntilExecution = dayjs(dateTimeString).diff(
    undefined,
    "millisecond",
  )

  if (timeUntilExecution > maxDelay) {
    let clearTimeoutCallback: ClearTimeoutCallback

    const timeoutId = setTimeout(
      () => {
        clearTimeoutCallback = setTimeoutForTime(
          dateTimeString,
          callback,
        )
      },
      maxDelay,
    )

    clearTimeoutCallback = () => {
      clearTimeout(timeoutId)
    }

    return () => {
      clearTimeoutCallback()
    }
  }

  const timeoutId = setTimeout(
    callback,
    timeUntilExecution,
  )

  return () => {
    clearTimeout(timeoutId)
  }
}
